import { FC } from 'react'
import { useRouter } from 'next/router'
import { Typography } from '@mui/material'
import { useConsentStore } from 'store/consentStore'

interface CookieSettingsLinkProps {
  color: string
  fontFamily?: string
  bold?: boolean
}

export const CookieSettingsLink: FC<CookieSettingsLinkProps> = ({ color, fontFamily, bold }) => {
  const { iframe } = useRouter().query
  const openSettings = useConsentStore((state) => state.openSettings)

  if (iframe) return null

  return (
    <Typography
      component="button"
      type="button"
      variant="body2"
      onClick={openSettings}
      fontFamily={fontFamily}
      fontWeight={bold ? 600 : undefined}
      sx={{ color, p: 0, border: 0, bgcolor: 'transparent', cursor: 'pointer' }}
    >
      Cookie Settings
    </Typography>
  )
}
